import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

export default function About() {
  return (
    <section id="about" className="bg-cream py-24 sm:py-32" data-testid="about-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <p className="eyebrow text-arc mb-6">About ArcView Homes</p>
          </Reveal>
          <MaskedLines
            className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl"
            lines={[<>More Than a House.</>, <>A Home Designed <span className="italic text-gradient">Around You.</span></>]}
          />
          <Reveal delay={0.2}>
            <p className="mt-8 text-base sm:text-lg leading-relaxed text-mist">
              At ArcView Homes, we believe your home should reflect the way you live. Our team
              combines architectural design, drafting, approvals and custom construction to create
              homes that are practical, distinctive and tailored to each client's needs.
            </p>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-mist">
              With an in-house architect and custom builders, we provide an integrated approach that
              keeps your project connected from the initial idea through to construction and
              handover.
            </p>
            <a
              href="#contact"
              data-testid="about-cta-meet-arcview"
              className="group mt-9 inline-flex items-center gap-3 font-semibold text-charcoal border-b-2 border-arc pb-1 hover:text-arc transition-colors duration-300"
            >
              Meet ArcView Homes
              <ArrowRight size={17} className="group-hover:translate-x-1.5 transition-transform duration-300" />
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="relative">
          <div className="absolute -top-5 -left-5 w-full h-full border border-arc/40" aria-hidden="true" />
          <div className="relative overflow-hidden">
            <img
              src={IMAGES.about}
              alt="Contemporary Australian residential architecture"
              loading="lazy"
              className="w-full h-[420px] sm:h-[540px] object-cover hover:scale-105 transition-transform duration-[1.4s] ease-out"
              data-testid="about-image"
            />
          </div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-mist mt-4 text-right">
            Architectural design — Tarneit, VIC
          </p>
        </Reveal>
      </div>
    </section>
  );
}
